<div class="modal fade" id="labelpreparation-export-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog dw-modal" role="document">
        <div class="modal-content ">
            <div class="modal-header">
                <h4 class="mb-0">Label Preparation Setup: {{ labelPreparationSetupName }}</h4>
            </div>
            <div class="modal-body">
                <div class="col-12">
                    <div>
                        You have selected <b> {{ this.labelPreparationExportEntryIds.length }} </b> 
                        entries to be listed for label preparation. If this is okay, 
                        then please proceed to download either a CSV version of the label output. 
                        You can then proceed to add the output file to your label printing software.
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="modal-footer">
                    <input 
                        type="button"
                        class="btn btn-secondary"
                        value="Download CSV"
                        (click)="download('csv')"
                    />
                    <input 
                        #labelPreparationExportModalCloseButton
                        type="button" 
                        data-bs-dismiss="modal"
                        class="btn btn-secondary"
                        value="Close" 
                    />
                </div>
            </div>
        </div>
    </div>
</div>

